import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import Ocurrences from './Ocurrences';

const OcurrencesWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'Ocorrências',
            }}
        >
            <Ocurrences />
        </ServicesChartsDataProvider>
    );
};

export default OcurrencesWrapper;
